module.exports = __webpack_public_path__ + "img/icon-checked-green.8db0d6e5.svg";